export const AUTH = {
    "LOGIN_PATH": process.env.REACT_APP_LOGIN_ROOT,
    "LOGOUT_PATH" : process.env.REACT_APP_LOGOUT_ROOT,
    "CLIENT_ID": process.env.REACT_APP_CLIENT_ID,
    "CLIENT_SECRET": process.env.REACT_APP_CLIENT_SECRET
};